import { Navigate } from "react-router-dom";
import MainLayout from "../components/Layouts/MainLayout";
import Home from "../features/home/layout/Home";
import SurveyEnd from "../features/survey/components/SurveyEnd";
import DoneSurveys from "../features/doneSurvey/layout/DoneSurveys";
import PendingSurveys from "../features/pendingSurvey/layout/PendingSurveys";


type PrivateRouteProps = {
  children: React.ReactNode;
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

export const protectedRoutes = [
    {
        path: '/',
        element: (
            <PrivateRoute>
                <MainLayout />
            </PrivateRoute>
        ),
        children: [
            {
                path: '/',
                element: <Home />, 
                children: [
                    { path: '', element: <Navigate to="pending-surveys" replace /> }, 
                    { path: 'done-surveys', element: <DoneSurveys /> },
                    { path: 'pending-surveys', element: <PendingSurveys /> },
                ],
            },
            { path: 'end-survey/:surveyId/:order', element: <SurveyEnd /> }, 
        ],
    },
];

